import api from "./http";

const API_URL = `/api/collaborateurs`;

function toApiPayload(data) {
  const payload = {
    nom: data.nom,
    prenom: data.prenom,
    email: data.email,
  };
  if (data.password) {
    payload.password = data.password;
  }
  if (data.role) {
    payload.roleId = `/api/roles/${data.role}`;
  }
  return payload;
}

function fromApiListResponse(data) {
  if (data && Array.isArray(data["hydra:member"])) {
    return data["hydra:member"]; 
  }
  if (data && Array.isArray(data["member"])) {
    return data["member"]; 
  }
  return Array.isArray(data) ? data : [];
}

const ACCEPT_JSONLD = { headers: { Accept: "application/ld+json" } };
const JSONLD_HEADERS = { headers: { "Content-Type": "application/ld+json", Accept: "application/ld+json" } };
const MERGE_PATCH_HEADERS = { headers: { "Content-Type": "application/merge-patch+json", Accept: "application/ld+json" } };

export async function getCollaborateurs() {
  let allCollaborateurs = [];
  let url = `${API_URL}?itemsPerPage=1000&pagination=false&page=1`;

  while (url) {
    const res = await api.get(url, ACCEPT_JSONLD);
    const data = res.data;
    allCollaborateurs = allCollaborateurs.concat(fromApiListResponse(data));

    if (data.view && data.view.next) {
      url = data.view.next;
    } else if (data["hydra:view"] && data["hydra:view"]["hydra:next"]) {
      url = data["hydra:view"]["hydra:next"];
    } else {
      url = null;
    }
  }

  return allCollaborateurs;
}

export async function addCollaborateur(data) {
  const res = await api.post(API_URL, toApiPayload(data), JSONLD_HEADERS);
  return res.data;
}

export async function updateCollaborateur(id, data) {
  const res = await api.patch(`${API_URL}/${id}`, toApiPayload(data), MERGE_PATCH_HEADERS);
  return res.data;
}

export async function deleteCollaborateur(id) {
  await api.delete(`${API_URL}/${id}`, ACCEPT_JSONLD);
}